<template>
  <div>
    <prezydencki-template :schema="schema" />

    <w-input class="mb-2" :model="schema.date" />

    <w-input class="mb-2" :model="schema.time" />

    <w-input class="mb-2" :model="schema.place" />

    <w-input class="mb-2" :model="schema.directorName" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import PrezydenckiTemplate from './components/PrezydenckiTemplate';

// @vuese
// Formularz dyplomu
// @group ActionData
export default {
  components: { ...components, PrezydenckiTemplate },
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
